var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Cabecera'),_c('h1',[_vm._v("Hola aqui viene despues del correo")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }